<template>
    <section>
        <div class="twitter-widget" style="width:400px;">
            <v-timeline
                :id="twitterId"
                :source-type="sourceType"
                :options="{ 'height': twitterHeight }" />
        </div>
    </section>
</template>

<script>
    import Timeline from 'vue-tweet-embed/dist/timeline'

    export default {
        name: "twitter-embed",
        components: {
            'v-timeline': Timeline,
        },
        data: function () {
            return {
                twitterId: 'tocho_koho',
                sourceType: 'profile',
                twitterHeight: 600,
            }
        },
    }
</script>

<style scoped>
</style>
